import * as Yup from "yup";

interface FormValues {
  phone: string;
  email: string;
  location: string;
  linkedinProfile: string;
  github: string;
  website: string;
}

export const schema = Yup.object().shape({
  phone: Yup.string(),
  email: Yup.string().email().required(),
  location: Yup.string(),
  linkedinProfile: Yup.string(),
  github: Yup.string(),
  website: Yup.string(),
});

export const initialValues = (initialValues = {}): FormValues => {
  return {
    phone: "",
    email: "",
    location: "",
    linkedinProfile: "",
    github: "",
    website: "",
    ...initialValues,
  };
};
